import { Popover } from "antd";
import useTranslation from "utils/hooks/useTranslation";
export const ValueBlock: React.FC<{
  value: string | number;
  isTitle?: boolean;
  isWarning?: boolean;
  helpText?: string;
  textSize?: number | string;
}> = ({ value, isTitle, isWarning, helpText, textSize }) => {
  const { t } = useTranslation();
  return (
    <group
      data-length="260"
      data-height="50"
      data-border="inset"
      data-space-horizontal="10"
      data-align="center"
      data-justify="center"
    //data-background="red"
    >
      {isTitle ? (
        <text
          data-position="center"
          data-weight="500"
          {...(isWarning ? { "data-color": "error-color" } : {})}
        >
          {value}
        </text>
      ) : (
        <group data-align="center" data-wrap="no" data-gap="5" >
          <text
            data-position="center"
            data-color={isWarning ? "error-color" : "grey-color-dark"}
            data-weight="400"
            data-text-size={textSize}
          >
            {value}
          </text>
          {isWarning && helpText && (
            <Popover
              trigger="hover"
              color="var(--error-color)"
              overlayInnerStyle={{ width: 200 }}
              content={
                <group data-direction="column" data-gap="10" data-space="5">
                  <div
                    data-wrap="wrap"
                    dangerouslySetInnerHTML={{ __html: t(helpText) }}
                  />
                </group>
              }
            >
              <icon data-icon-size={textSize} data-color="error-color" style={{ cursor: "pointer" }}>
                warning
              </icon>
            </Popover>
          )}
        </group>
      )}
    </group>
  )
}
